import * as types from "./types";
import { normalizeFranchiseName } from "@/helpers/franchise";

const normalizeFranchisePayload = (payload) => {
  if (!payload || !Array.isArray(payload.data)) {
    return payload;
  }

  return {
    ...payload,
    data: payload.data.map((item) => ({
      ...item,
      franchise_name: normalizeFranchiseName(item?.franchise_name || ""),
    })),
  };
};

export default {
  [types.MUTATE_PLANNED_OKR_TOTALIZER]: (state, payload) => {
    state.plannedOkrTotalizer = payload;
  },
  [types.MUTATE_PLANNED_OKR_LIST]: (state, payload) => {
    state.plannedOkrList = normalizeFranchisePayload(payload);
  },
  [types.MUTATE_OKR_OVERVIEW_TOTALIZER]: (state, payload) => {
    state.okrOverviewTotalizer = payload;
  },
  [types.MUTATE_OKR_OVERVIEW_LIST]: (state, payload) => {
    state.okrOverviewList = normalizeFranchisePayload(payload);
  },
  [types.MUTATE_HISTORICAL_PERFORMANCE]: (state, payload) => {
    state.historicalPerformance = payload;
  },
  [types.MUTATE_INTERVIEW_EFFICIENCY_BY_KEY]: (state, { key, data }) => {
    state.interviewEfficiencyByKey = {
      ...(state.interviewEfficiencyByKey || {}),
      [key]: data,
    };
  },
};
